module.exports = __webpack_public_path__ + "static/img/noCertified.44585e25.png";